import React from "react";
import { Box } from "@mui/material";
import { t } from "i18next";
import { useSelector } from "react-redux";

import { Icon, ButtonComp } from "components";
import { getIsMaximized, getIsMobileWindow, selectIsPhotoTourScreen, selectIsVideoTourScreen, unitSliceData } from "slices";

const FeedBackModal = ({ page, rating, setRating, comment, setComment, setModal, handleFeedbackSubmit, feedbackLoader, type }) => {
  const isMaximized = useSelector(getIsMaximized);
  const isVideoTourScreen = useSelector(selectIsVideoTourScreen);
  const isPhotoTourScreen = useSelector(selectIsPhotoTourScreen);
  const { isUnitTourScreen } = useSelector(unitSliceData);
  const ratings = [t("excellent"), t("needImprovement")];
  const isMobile = useSelector(getIsMobileWindow);

  const isLike = rating === t("excellent");

  const getPlaceholder = (type) => {
    switch (type) {
      case t("complaint"):
        return t("writeComplaint");

      case t("needImprovement"):
        return t("whatNeedToImprove");

      default:
        return t("whatULike");
    }
  };

  const getTitle = (type) => {
    switch (type) {
      case t("complaint"):
        return t("complaint");

      default:
        return t("feedback");
    }
  };

  const getButtonLabel = (type, isLoading) => {
    if (isLoading) {
      return t("submitting");
    } else if (type === t("complaint")) {
      return t("submit");
    }

    return t("submitFeedback");
  };

  const isSubmitDisabled = () => {
    if (feedbackLoader) {
      return true;
    }

    if (rating === t("complaint")) {
      return comment.trim() === "";
    }

    return !rating || comment.trim() === "";
  };

  const onClose = () => {
    setModal(false);
  };

  const getContainerClass = (isMaximized, isVideoTourScreen, isPhotoTourScreen, isUnitTourScreen, isMobile, page) => {
    return `${page === "feedback" ? "hayley-absolute" : "hayley-absolute"} hayley-z-50  hayley-bg-white  ${
      (isMaximized || isVideoTourScreen || isPhotoTourScreen || isUnitTourScreen) && !isMobile
        ? `shadow-md classic-shadow  ${
            page === "feedback"
              ? `${rating === t("complaint") && !isMobile ? "hayley-translate-y-1/2" : "hayley-translate-y-1/4"} hayley-left-1/2 hayley--translate-x-1/2`
              : "hayley-right-0"
          } hayley-mt-[-16px] hayley-w-full sm:hayley-w-[500px] hayley-rounded-l-lg hayley-rounded-r-none`
        : "hayley-w-full hayley-rounded-lg  hayley-shadow-lg"
    }`;
  };

  return (
    <Box className={getContainerClass(isMaximized, isVideoTourScreen, isPhotoTourScreen, isUnitTourScreen, isMobile, page)}>
      {page === "feedback" ? (
        <>
          <Box className={"hayley-flex hayley-h-[50px] hayley-items-center hayley-justify-between hayley-p-4"}>
            <Box className="hayley-font-medium hayley-capitalize">{`Hayley Mail ${getTitle(rating)}`}</Box>

            <Box className="hayley-cursor-pointer" onClick={onClose}>
              <Icon iconType="Cancel" className="hayley-h-[18px] hayley-w-[20px] hayley-text-inherit" />
            </Box>
          </Box>
          <Box className="hayley-w-100 hayley-h-[1px] hayley-bg-[#DADADA]" />
        </>
      ) : null}

      <Box className="hayley-space-y-3 hayley-p-4">
        {/* Hide the feedback options when rating = "complaint" */}
        {rating === t("complaint") ? (
          <Box className={"hayley-color-[#666666] hayley-text-sm"}>{t("complaintDescription")}</Box>
        ) : (
          <>
            <Box className={!(isMaximized || isVideoTourScreen || isPhotoTourScreen || isUnitTourScreen) && "hayley-text-sm"}>
              {isLike ? t("chatbotLikeQuestion") : t("chatbotExpQuestion")}
            </Box>

            <Box className="hayley-flex hayley-flex-wrap">
              {ratings.map((v, i) => (
                <ButtonComp
                  key={i}
                  selected={v === rating}
                  icon={v === t("excellent") ? "like" : "dislike"}
                  label={v}
                  onClick={() => setRating(v)}
                  disabled={false}
                  className="!hayley-mb-2 !hayley-mr-2 !hayley-px-5 !hayley-py-2"
                />
              ))}
            </Box>
          </>
        )}

        <textarea
          data-testid="give_feedback_textarea"
          className="hayley-h-32 hayley-w-full hayley-border hayley-border-gray-300 hayley-p-4 hayley-font-sans hayley-text-sm hayley-placeholder-gray-500 hayley-outline-none focus:hayley-border-gray-300"
          onChange={(e) => setComment(e.target.value)}
          placeholder={getPlaceholder(rating)}
          style={{ resize: "none" }}
          value={comment}
        />
        <Box className="hayley-flex hayley-space-x-2">
          <ButtonComp label={getButtonLabel(rating, feedbackLoader)} onClick={handleFeedbackSubmit} disabled={isSubmitDisabled()} filled={true} />
          {feedbackLoader ? null : <ButtonComp label={t("cancel")} onClick={onClose} disabled={false} border={false} />}
        </Box>
      </Box>
    </Box>
  );
};

export default FeedBackModal;
